import './Project.css';
import Header from './components/Header';
import { ProjectGrid } from './components/ProjectGrid';
import { NavBar } from '../../utility/navBar/Navbar';
import { Contact } from '../../utility/contact/Contact';
import { useEffect } from 'react';

export const Project = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0});
    }, []);

    return (
        <section className={`project`}>
            <NavBar theme='light' />
            <Header />
            <ProjectGrid />
            <Contact />
        </section>
    );
};